/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Page_FeatureInputs */

const en_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Plus Advanced Features
Upgrade your focus experience!

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Focus Timer | ✔️ | ✔️ | ✔️ |
| Duration Statistics | ✔️ | ✔️ | ✔️ |
| Plant together  | ✔️ | ✔️ | ✔️ |
| Deep Focus Mode | ✔️ | ✔️ | ✔️ |
| Custom App Allow List | - | ✔️ | ✔️ |
| Remove Ads | - | ✔️ | ✔️ |
| Focus trend analysis | - | ✔️ | ✔️ |
| Plant real trees* | - | ✔️ | ✔️ |
| Custom Focus Tags | - | ✔️ | ✔️ |
| Auto-start Next Session | - | ✔️ | ✔️ |
| 3x focus coin | - | - | ✔️ |
| Enjoy Plus Exclusive Trees | - | - | ✔️ |
| Early Access to Seasonal New Trees | - | - | ✔️ |
| Enjoy Seasonal Select Crystal Trees | - | - | ✔️ |
| [Time Guard] Block more interruptive apps | - | - | ✔️ |
| [Mindful Space] Enjoy various Soundscape | - | - | ✔️ |

* *The maximum limit for planting real trees is 5.

- Pro users include iOS users who have paid to download Forest from the App Store, as well as Android users who have unlocked the Pro version. 
- For Pro users, all Pro features and benefits that were originally unlocked will be retained for life, regardless of subscription status.`)
};

const ar_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# ميزات متقدمة إضافية
قم بترقية تجربة التركيز الخاصة بك!

|  | مجاني | احترافي | بلس |
| --- | --- | --- | --- |
| مؤقت التركيز | ✔️ | ✔️ | ✔️ |
| إحصائيات المدة | ✔️ | ✔️ | ✔️ |
| ازرعوا معًا | ✔️ | ✔️ | ✔️ |
| وضع التركيز العميق | ✔️ | ✔️ | ✔️ |
| تطبيق مخصص قائمة السماح | - | ✔️ | ✔️ |
| إزالة الإعلانات | - | ✔️ | ✔️ |
| تحليل اتجاه التركيز | - | ✔️ | ✔️ |
| ازرع أشجارًا حقيقية* | - | ✔️ | ✔️ |
| علامات التركيز المخصصة | - | ✔️ | ✔️ |
| بدء الجلسة التالية تلقائيًا | - | ✔️ | ✔️ |
| عملة التركيز 3x | - | - | ✔️ |
| نَمِّى أشجار حصرية من بلس | - | - | ✔️ |
| استمتع بأشجار جديدة في كل موسم | - | - | ✔️ |
| استمتع بـ أشجار كريستالية موسمية مختارة | - | - | ✔️ |
| [حارس الوقت] احظر المزيد من التطبيقات المُشتِّتة | - | - | ✔️ |
| [مساحة اليقظة] استمتع بمجموعة متنوعة من منظر صوتي | - | - | ✔️ |

* *الحد الأقصى لزراعة الأشجار الحقيقية هو 5.

- يشمل مستخدمو نسخة المحترفين مستخدمي iOS الذين دفعوا مقابل تنزيل Forest من متجر آبل، بالإضافة إلى مستخدمي آندرويد الذين قاموا بفتح نسخة المحترفين. 
 - بالنسبة لمستخدمي نسخة المحترفين، سيتم الاحتفاظ بجميع ميزات وفوائد نسخة المحترفين التي تم فتحها في الأصل مدى الحياة، بغض النظر عن حالة الاشتراك.`)
};

const de_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Plus Erweiterte Funktionen
Verbessern Sie Ihr Fokus-Erlebnis!

|  | Kostenlos | Pro | Plus |
| --- | --- | --- | --- |
| Fokus-Timer | ✔️ | ✔️ | ✔️ |
| Dauerstatistik | ✔️ | ✔️ | ✔️ |
| Gemeinsam pflanzen | ✔️ | ✔️ | ✔️ |
| Deep-Focus-Modus | ✔️ | ✔️ | ✔️ |
| Benutzerdefinierte App Liste zulassen | - | ✔️ | ✔️ |
| Anzeigen entfernen | - | ✔️ | ✔️ |
| Schwerpunkt Trendanalyse | - | ✔️ | ✔️ |
| Echte Bäume pflanzen* | - | ✔️ | ✔️ |
| Benutzerdefinierte Fokus-Tags | - | ✔️ | ✔️ |
| Automatischer Start der nächsten Sitzung | - | ✔️ | ✔️ |
| 3x Fokusmünze | - | - | ✔️ |
| Genieße exklusive Plus-Bäume | - | - | ✔️ |
| Versuchen Sie zuerst Neue Bäume der Saison | - | - | ✔️ |
| Genießen Sie Saisonal ausgewählte Kristallbäume | - | - | ✔️ |
| [Zeitwächter] Blockieren Sie mehr unterbrechende Apps | - | - | ✔️ |
| [Achtsamer Raum] Genießen Sie verschiedene Klanglandschaft | - | - | ✔️ |

* *Maximal 5 echte Bäume können gepflanzt werden.

- Pro-Nutzer sind iOS-Nutzer, die für den Download von Forest aus dem App Store bezahlt haben, sowie Android-Nutzer, die die Pro-Version freigeschaltet haben. 
- Für Pro-Nutzer bleiben alle Pro-Funktionen und Vorteile, die ursprünglich freigeschaltet wurden, lebenslang erhalten, unabhängig vom Abonnementstatus.`)
};

const es_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Funciones avanzadas de Plus
Mejora tu experiencia de concentración

|  | Gratis | Pro | Plus |
| --- | --- | --- | --- |
| Temporizador de concentración | ✔️ | ✔️ | ✔️ |
| Estadísticas de duración | ✔️ | ✔️ | ✔️ |
| Plantar juntos | ✔️ | ✔️ | ✔️ |
| Modo de concentración profunda | ✔️ | ✔️ | ✔️ |
| Lista personalizada de apps permitidas | - | ✔️ | ✔️ |
| Elimina los anuncios | - | ✔️ | ✔️ |
| Análisis de tendencias de concentración | - | ✔️ | ✔️ |
| Planta árboles reales* | - | ✔️ | ✔️ |
| Etiquetas de concentración personalizadas | - | ✔️ | ✔️ |
| Inicio automático de la siguiente sesión | - | ✔️ | ✔️ |
| Moneda de concentración x3 | - | - | ✔️ |
| Disfruta de los Árboles exclusivos Plus | - | - | ✔️ |
| Prueba los Nuevos árboles de temporada primero | - | - | ✔️ |
| Disfruta los Árboles de cristal de temporada seleccionados | - | - | ✔️ |
| [Guardián del Tiempo] Bloquea las apps más intrusivas | - | - | ✔️ |
| [Espacio consciente] Disfruta de diversos paisajes sonoros | - | - | ✔️ |

* *El límite máximo para plantar árboles reales es de 5.

- Entre los usuarios de Pro se incluyen los usuarios de iOS que hayan pagado para descargar Forest de la App Store, así como los usuarios de Android que hayan desbloqueado la versión Pro. 
- Para los usuarios de Pro, todas las características y beneficios Pro que fueron desbloqueados originalmente se mantendrán de por vida, independientemente del estado de suscripción.`)
};

const fr_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Fonctionnalités Avancées Plus
Améliorez votre expérience de concentration!

|  | Gratuit | Pro | Plus |
| --- | --- | --- | --- |
| Minuteur de concentration | ✔️ | ✔️ | ✔️ |
| Statistiques de durée | ✔️ | ✔️ | ✔️ |
| Planter Ensemble | ✔️ | ✔️ | ✔️ |
| Mode Concentration Profonde | ✔️ | ✔️ | ✔️ |
| Liste des autorisations personnalisée | - | ✔️ | ✔️ |
| Supprimer les publicités | - | ✔️ | ✔️ |
| Analyse des tendances de concentration | - | ✔️ | ✔️ |
| Plantez de véritables arbres* | - | ✔️ | ✔️ |
| Tags personnalisables | - | ✔️ | ✔️ |
| Démarrage automatique de la prochaine session | - | ✔️ | ✔️ |
| Triplez vos pièces obtenues | - | - | ✔️ |
| Profitez des arbres exclusifs Plus | - | - | ✔️ |
| Essayez les Nouveaux arbres saisonniers en premier | - | - | ✔️ |
| Profitez d'Arbres premium de saison | - | - | ✔️ |
| [Gardien du Temps] Bloquer plus d'applications dérangeantes | - | - | ✔️ |
| [Espace de relaxation] Profitez d'une multitude de Paysages sonores | - | - | ✔️ |

* *Vous pouvez planter jusqu’à 5 vrais arbres.

- Les utilisateurs Pro comprennent les utilisateurs iOS qui ont payé pour télécharger Forest depuis l'App Store, ainsi que les utilisateurs Android qui ont débloqué la version Pro.
- Pour les utilisateurs Pro, toutes les fonctionnalités et avantages Pro initialement débloqués sont conservés à vie, quel que soit le statut de l'abonnement.`)
};

const it_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Funzionalità Plus Avanzate
Migliora la tua esperienza di concentrazione!

|  | Gratis | Pro | Plus |
| --- | --- | --- | --- |
| Timer di concentrazione | ✔️ | ✔️ | ✔️ |
| Statistiche sulla durata | ✔️ | ✔️ | ✔️ |
| Pianta in gruppo | ✔️ | ✔️ | ✔️ |
| Modalità Concentrazione Intensiva | ✔️ | ✔️ | ✔️ |
| Lista App Consentite personalizzata | - | ✔️ | ✔️ |
| Rimuovi annunci | - | ✔️ | ✔️ |
| Analisi del trend di concentrazione | - | ✔️ | ✔️ |
| Pianta alberi veri* | - | ✔️ | ✔️ |
| Tag personalizzati | - | ✔️ | ✔️ |
| Avvio automatico della sessione successiva | - | ✔️ | ✔️ |
| 3x monete di concentrazione | - | - | ✔️ |
| Goditi gli alberi esclusivi Plus | - | - | ✔️ |
| Prova prima gli Nuovi alberi stagionali | - | - | ✔️ |
| Goditi la Selezione stagionale degli alberi di cristalli | - | - | ✔️ |
| [Time Guard] Blocca più app interruttive | - | - | ✔️ |
| [Spazio Mindful] Goditi vari Soundscape | - | - | ✔️ |

* *Il limite massimo di alberi veri piantabili è 5.

- Gli Utenti Pro includono gli utenti iOS che hanno pagato per scaricare Forest dall'App Store, così come gli utenti Android che hanno sbloccato la versione Pro. 
- Per gli Utenti Pro, tutte le funzionalità e i vantaggi Pro originariamente sbloccati verranno mantenuti a vita, indipendentemente dallo stato dell'abbonamento.`)
};

const ja_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Plusの高度な機能
集中力を向上させよう！

|  | 無料 | Pro | Plus |
| --- | --- | --- | --- |
| フォーカスタイマー | ✔️ | ✔️ | ✔️ |
| 期間統計 | ✔️ | ✔️ | ✔️ |
| 一緒に植える | ✔️ | ✔️ | ✔️ |
| ディープフォーカスモード | ✔️ | ✔️ | ✔️ |
| アプリの許可リストのカスタマイズ | - | ✔️ | ✔️ |
| 広告の削除 | - | ✔️ | ✔️ |
| 集中傾向の分析 | - | ✔️ | ✔️ |
| 本物の木を植える* | - | ✔️ | ✔️ |
| フォーカスタグのカスタマイズ | - | ✔️ | ✔️ |
| 次のセッションを自動開始 | - | ✔️ | ✔️ |
| 獲得コイン3倍 | - | - | ✔️ |
| Plus限定の木を楽しもう | - | - | ✔️ |
| シーズン限定の新しい木を先行お試し | - | - | ✔️ |
| シーズン限定クリスタルツリーを楽しむ | - | - | ✔️ |
| [タイムガード] 邪魔なアプリをさらにブロック | - | - | ✔️ |
| [森のリトリート] さまざまなサウンドスケープ | - | - | ✔️ |

* *植えられる本物の木は最大5本です。

- プロユーザーには、App StoreからForestを有料でダウンロードしたiOSユーザーと、プロ版をアンロックしたAndroidユーザーが含まれます。 
- プロユーザーの場合、サブスクリプションのステータスに関係なく、最初にアンロックされたすべてのプロ機能と特典は生涯ご利用いただけます。`)
};

const ko_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Plus 고급 기능
집중 경험을 업그레이드하세요!

|  | 무료 | Pro | Plus |
| --- | --- | --- | --- |
| 집중 타이머 | ✔️ | ✔️ | ✔️ |
| 기간 통계 | ✔️ | ✔️ | ✔️ |
| 함께 심기 | ✔️ | ✔️ | ✔️ |
| 딥 포커스 모드 | ✔️ | ✔️ | ✔️ |
| 커스텀 앱 앱 허용 리스트 | - | ✔️ | ✔️ |
| 광고 제거 | - | ✔️ | ✔️ |
| 집중 추세 분석 | - | ✔️ | ✔️ |
| 실제 나무 기부하기* | - | ✔️ | ✔️ |
| 사용자 지정 포커스 태그 | - | ✔️ | ✔️ |
| 다음 세션 자동 시작 | - | ✔️ | ✔️ |
| 포커스 코인 3배 획득 | - | - | ✔️ |
| Plus 전용 나무를 즐겨보세요 | - | - | ✔️ |
| 누구보다 먼저 시즌별 신규 나무를 만나세요 | - | - | ✔️ |
| 시즌별 엄선된 크리스탈 나무를 만나보세요 | - | - | ✔️ |
| [타임 가드] 방해되는 앱 차단 한도 증가 | - | - | ✔️ |
| [마음챙김 공간] 다양한 사운드스케이프 지원 | - | - | ✔️ |

* *심을 수 있는 실제 나무는 최대 5그루입니다.

- Pro 사용자에는 앱 스토어에서 유료로 Forest를 다운로드한 iOS 사용자와 Pro 버전을 구입한 Android 사용자가 포함됩니다. 
- Pro 사용자의 경우, 기존에 구입한 모든 Pro 기능 및 혜택은 구독 상태와 관계없이 평생 유지됩니다.`)
};

const pt_br_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Funcionalidades avançadas Plus
Eleve o nível da sua experiência de foco!

|  | Free | Pro | Plus |
| --- | --- | --- | --- |
| Temporizador de foco | ✔️ | ✔️ | ✔️ |
| Estatísticas de duração | ✔️ | ✔️ | ✔️ |
| Plantar juntos | ✔️ | ✔️ | ✔️ |
| Modo Foco Total | ✔️ | ✔️ | ✔️ |
| Lista de permissões personalizada | - | ✔️ | ✔️ |
| Remoção de anúncios | - | ✔️ | ✔️ |
| Análise das tendências de foco | - | ✔️ | ✔️ |
| Plante árvores reais* | - | ✔️ | ✔️ |
| Tags de foco personalizadas | - | ✔️ | ✔️ |
| Início automático da próxima sessão | - | ✔️ | ✔️ |
| 3x mais moedas | - | - | ✔️ |
| Aproveite Árvores exclusivas Plus | - | - | ✔️ |
| Experimente as Novas árvores sazonais primeiro | - | - | ✔️ |
| Aproveite as Árvores sazonais de Cristais do Tempo | - | - | ✔️ |
| [Vigia do Tempo] Bloqueie os aplicativos que mais te interrompem | - | - | ✔️ |
| [Espaço Consciente] Aproveite várias paisagens sonoras | - | - | ✔️ |

* *O limite máximo para plantar árvores reais é 5.

- Usuários Pro incluem os usuários iOS que pagaram para baixar o Forest na App Store, assim como os usuários Android que desbloquearam a versão Pro.
- Para os usuários Pro, todas as funcionalidades e benefícios Pro que foram originalmente desbloqueados serão mantidos para sempre, independentemente do status da assinatura.`)
};

const ru_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Продвинутые Plus-функции
Улучшите свою сосредоточенность!

|  | Бесплатно | Pro | Plus |
| --- | --- | --- | --- |
| Таймер фокусировки | ✔️ | ✔️ | ✔️ |
| Статистика продолжительности | ✔️ | ✔️ | ✔️ |
| Сажать вместе | ✔️ | ✔️ | ✔️ |
| Режим глубокой фокусировки | ✔️ | ✔️ | ✔️ |
| Настраиваемый Список разрешений приложений | - | ✔️ | ✔️ |
| Удаление рекламы | - | ✔️ | ✔️ |
| Анализ тенденций фокусировки | - | ✔️ | ✔️ |
| Сажайте настоящие деревья* | - | ✔️ | ✔️ |
| Пользовательские теги фокуса | - | ✔️ | ✔️ |
| Автозапуск следующей сессии | - | ✔️ | ✔️ |
| в 3 раза больше монет за фокусировку | - | - | ✔️ |
| Наслаждайтесь эксклюзивными деревьями Plus | - | - | ✔️ |
| Попробуйте Новые сезонные деревья первым | - | - | ✔️ |
| Наслаждайтесь сезонными кристальными деревьями на выбор | - | - | ✔️ |
| [Контроль времени] Блокируйте больше отвлекающих приложений | - | - | ✔️ |
| [Пространство осознанности] Наслаждайтесь различными звуковыми ландшафтами | - | - | ✔️ |

* *Максимум можно посадить 5 настоящих деревьев.

- К пользователям Pro относятся пользователи iOS, оплатившие скачивание Forest из App Store, а также пользователи Android, разблокировавшие версию Pro. 
- Для пользователей Pro все функции и преимущества Pro, которые были изначально разблокированы, сохраняются навсегда, независимо от статуса подписки.`)
};

const th_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# คุณสมบัติขั้นสูงของ Plus
อัปเกรดประสบการณ์การโฟกัสของคุณ!

|  | ฟรี | โปร | Plus |
| --- | --- | --- | --- |
| ตัวจับเวลาการโฟกัส | ✔️ | ✔️ | ✔️ |
| สถิติระยะเวลา | ✔️ | ✔️ | ✔️ |
| ปลูกต้นไม้ด้วยกัน | ✔️ | ✔️ | ✔️ |
| โหมดโฟกัสเต็มที่ | ✔️ | ✔️ | ✔️ |
| รายการอนุญาตแอปที่กำหนดเอง | - | ✔️ | ✔️ |
| ลบโฆษณา | - | ✔️ | ✔️ |
| การวิเคราะห์เทรนด์การโฟกัส | - | ✔️ | ✔️ |
| ปลูกต้นไม้จริง* | - | ✔️ | ✔️ |
| แท็กการโฟกัสที่กำหนดเอง | - | ✔️ | ✔️ |
| เริ่มเซสชันถัดไปอัตโนมัติ | - | ✔️ | ✔️ |
| เหรียญการโฟกัส 3 เท่า | - | - | ✔️ |
| เพลิดเพลินกับต้นไม้สุดพิเศษสำหรับ Plus | - | - | ✔️ |
| ลองปลูกต้นไม้ใหม่ประจำฤดูกาลก่อนใคร | - | - | ✔️ |
| เพลิดเพลินกับต้นไม้คริสตัลที่คัดสรรตามฤดูกาล | - | - | ✔️ |
| [การปกป้องเวลา] บล็อกแอปที่รบกวนได้มากขึ้น | - | - | ✔️ |
| [พื้นที่ฝึกสติ] เพลิดเพลินกับทัศนียภาพแห่งเสียงที่หลากหลาย | - | - | ✔️ |

* *ขีดจำกัดสูงสุดในการปลูกต้นไม้จริงคือ 5 ต้น

- ผู้ใช้โปรได้แก่ ผู้ใช้ iOS ที่ชำระเงินเพื่อดาวน์โหลด Forest จาก App Store รวมถึงผู้ใช้ Android ที่ปลดล็อกเวอร์ชันโปรแล้ว
- สำหรับผู้ใช้โปร คุณสมบัติและสิทธิประโยชน์โปรทั้งหมดที่ถูกปลดล็อกตั้งแต่เดิมจะคงอยู่ตลอดชีพ ไม่ว่าสถานะการสมัครสมาชิกจะเป็นแบบใดก็ตาม`)
};

const tr_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Plus Gelişmiş Özellikler
Odaklanma deneyimini yükselt!

|  | Ücretsiz | Pro | Plus |
| --- | --- | --- | --- |
| Odak Zamanlayıcısı | ✔️ | ✔️ | ✔️ |
| Süre İstatistikleri | ✔️ | ✔️ | ✔️ |
| Birlikte ağaç dikin | ✔️ | ✔️ | ✔️ |
| Derin Odak Modu | ✔️ | ✔️ | ✔️ |
| Özel Uygulama İzin Listesi | - | ✔️ | ✔️ |
| Reklamları Kaldır | - | ✔️ | ✔️ |
| Odaklanma trend analizi | - | ✔️ | ✔️ |
| Gerçek ağaçlar dik* | - | ✔️ | ✔️ |
| Özel Odak Etiketleri | - | ✔️ | ✔️ |
| Sonraki Oturumu Otomatik Başlat | - | ✔️ | ✔️ |
| 3x odaklanma jetonu | - | - | ✔️ |
| Plus’a Özel Ağaçların keyfini çıkarın | - | - | ✔️ |
| Önce Mevsimsel Yeni Ağaçlarını dene | - | - | ✔️ |
| Mevsimsel Seçkin Kristal Ağaçlarnın keyfini çıkar | - | - | ✔️ |
| [Zaman Koruması] Daha fazla rahatsız edici uygulamayı engelle | - | - | ✔️ |
| [Farkındalık Alanı] Çeşitli ses manzaralarının tadını çıkar | - | - | ✔️ |

* *Gerçek ağaç dikmenin azami limiti 5’tir.

- Pro kullanıcıları, Forest'ı App Store'dan indirmek için ödeme yapan iOS kullanıcılarının yanı sıra Pro sürümünün kilidini açan Android kullanıcılarını da içerir. 
- Pro kullanıcılar için başlangıçta kilidi açılmış olan tüm Pro özellikleri ve avantajları, abonelik durumundan bağımsız olarak ömür boyu korunacaktır.`)
};

const zh_cn_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Plus 进阶功能
全面升级你的专注体验！

|  | 免费版 | 专业版 | Plus 会员 |
| --- | --- | --- | --- |
| 专注计时 | ✔️ | ✔️ | ✔️ |
| 时长统计 | ✔️ | ✔️ | ✔️ |
| 与好友一起种 | ✔️ | ✔️ | ✔️ |
| 深度专注 | ✔️ | ✔️ | ✔️ |
| 自订软件白名单 | - | ✔️ | ✔️ |
| 无广告 | - | ✔️ | ✔️ |
| 专注趋势分析 | - | ✔️ | ✔️ |
| 为地球种下真树* | - | ✔️ | ✔️ |
| 自订专注标签 | - | ✔️ | ✔️ |
| 自动下一轮专注 | - | ✔️ | ✔️ |
| 专注金币 3 倍 | - | - | ✔️ |
| 独享 Plus 限定树种 | - | - | ✔️ |
| 抢先体验每季最新树种 | - | - | ✔️ |
| 无限使用当季精选宝石树 | - | - | ✔️ |
| [时间守护] 阻挡多个干扰 App | - | - | ✔️ |
| [正念空间] 享受更多声音场景 | - | - | ✔️ |

* *种真树目前上限为 5 棵。

- 专业版用户包含 iOS 有在 App Store 付费下载过 Forest 或是 Android 有解锁专业版的用户
- 专业版用户原先解锁专业版的功能和权益都将终身保留，无论是否有购买 Plus 会员`)
};

const zh_tw_subscription_detail_page_feature = /** @type {(inputs: Subscription_Detail_Page_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`---
section: 2
---

# Plus 進階功能
全面升級你的專注體驗！

|  | 免費版 | 專業版 | 訂閱 Plus |
| --- | --- | --- | --- |
| 專注計時 | ✔️ | ✔️ | ✔️ |
| 時長統計 | ✔️ | ✔️ | ✔️ |
| 一起種 | ✔️ | ✔️ | ✔️ |
| 深度專注 | ✔️ | ✔️ | ✔️ |
| 自訂 App 允許名單 | - | ✔️ | ✔️ |
| 無廣告 | - | ✔️ | ✔️ |
| 專注趨勢分析 | - | ✔️ | ✔️ |
| 為地球種下真樹* | - | ✔️ | ✔️ |
| 自訂專注標籤 | - | ✔️ | ✔️ |
| 自動下一輪專注 | - | ✔️ | ✔️ |
| 專注金幣 3 倍 | - | - | ✔️ |
| 獨享 Plus 限定樹種 | - | - | ✔️ |
| 搶先體驗每季最新樹種 | - | - | ✔️ |
| 無限使用當季精選寶石樹 | - | - | ✔️ |
| [時間守護] 阻擋多個干擾 App | - | - | ✔️ |
| [正念空間] 享受更多聲音場景 | - | - | ✔️ |

* *種真樹目前上限為 5 棵。

- 專業版用戶包含 iOS 有在 App Store 付費下載過 Forest 或是 Android 有解鎖專業版的用戶
- 專業版用戶原先解鎖專業版的功能和權益都將終身保留，無論是否有訂閱`)
};

/**
* | output |
* | --- |
* | "--- section: 2 --- # Plus Advanced Features Upgrade your focus experience! \| \| Free \| Pro \| Plus \| \| --- \| --- \| --- \| --- \| \| Focus Timer \| ✔️ \| ✔️ \| ✔️ \| \|..." |
*
* @param {Subscription_Detail_Page_FeatureInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_page_feature = /** @type {((inputs?: Subscription_Detail_Page_FeatureInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Page_FeatureInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_page_feature(inputs)
	if (locale === "ar") return ar_subscription_detail_page_feature(inputs)
	if (locale === "de") return de_subscription_detail_page_feature(inputs)
	if (locale === "es") return es_subscription_detail_page_feature(inputs)
	if (locale === "fr") return fr_subscription_detail_page_feature(inputs)
	if (locale === "it") return it_subscription_detail_page_feature(inputs)
	if (locale === "ja") return ja_subscription_detail_page_feature(inputs)
	if (locale === "ko") return ko_subscription_detail_page_feature(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_page_feature(inputs)
	if (locale === "ru") return ru_subscription_detail_page_feature(inputs)
	if (locale === "th") return th_subscription_detail_page_feature(inputs)
	if (locale === "tr") return tr_subscription_detail_page_feature(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_page_feature(inputs)
	return zh_tw_subscription_detail_page_feature(inputs)
});